module.exports = __webpack_public_path__ + "img/dependentes.e12aaf2c.svg";